import * as Yup from "yup";

export const brandDetailsObject = {
  brandID: "",
  businessEntityId: "",
  brandName: "",
  website: "",
  profile: "",
  audienceLocation: [],
  audienceLanguages: [],
  socialMedia: {
    facebook: "",
    instagram: "",
    twitter: "",
    whatsapp: "",
  },
  brandAvatar: "",
  avatar: "",
  about: "",
  onlineStore: "",
  siteCategory: "",
  monthlyActiveUsers: "",
  others_category: "",
};

export function objectFromFormData(formData, businessEntityID) {
  let smh = {
    facebook: "",
    instagram: "",
    twitter: "",
    whatsapp: "",
  };

  let fb = formData.socialMedia?.facebook?.lastIndexOf("/");
  let ig = formData.socialMedia?.instagram?.lastIndexOf("/");
  let tw = formData.socialMedia?.twitter?.lastIndexOf("/");
  let wh = formData.socialMedia?.whatsapp?.lastIndexOf("/");

  smh.facebook = formData.socialMedia?.facebook?.substring(fb + 1);
  smh.instagram = formData.socialMedia?.instagram?.substring(ig + 1);
  smh.twitter = formData.socialMedia?.twitter?.substring(tw + 1);
  smh.whatsapp = formData.socialMedia?.whatsapp?.substring(wh + 1);

  return {
    business_entity_id: parseInt(businessEntityID),
    brand_name: formData.brandName,
    website: formData.website,
    audience_location: formData.audienceLocation,
    brandLogo: formData.brandAvatar,
    languages: formData.audienceLanguages,
    social_media_handles: smh,
    about: formData.about,
    online_store: formData.onlineStore,
    mau: parseInt(formData.monthlyActiveUsers),
    site_category: formData.siteCategory,
    company_name: formData.companyName,
    gst: formData.GSTNumber,
    contact_no: formData.compacontactNumber,
    address: formData.companyAddress,
    ...(formData.others_category && {
      others_category: formData.others_category,
    }),
  };
}

export function objectFromResponse(response, agencyID) {
  let medias = response?.social_media_handles;
  let fb = medias.facebook?.replace("@", "");
  let ig = medias.instagram?.replace("@", "");
  let tw = medias.twitter?.replace("@", "");

  return {
    brandAvatar: response.logo,
    brandID: response?.brand_id,
    businessEntityId: response.business_entity_id,
    brandName: response.brand_name,
    website: response.website,
    audienceLocation: response?.audience_location,
    audienceLanguages: response?.languages,
    siteCategory: response.site_category,
    others_category: response.others_category || "",
    socialMedia: {
      facebook: fb && "facebook.com/" + fb,
      instagram: ig && "instagram.com/" + ig,
      twitter: tw && "twitter.com/" + tw,
      whatsapp: medias.whatsapp,
    },
    about: response.about,
    onlineStore: response.online_store,
    monthlyActiveUsers:
      !response.mau || response.mau === "null" ? "" : response.mau,
    companyName: response?.company_details?.company_name,
    GSTNumber: response?.company_details?.gst,
    contactNumber: response?.company_details?.contact_no,
    companyAddress: response?.company_details?.address,
    ...(Boolean(agencyID) && { agencyID: agencyID }),
  };
}

export const validationSchema = Yup.object().shape({
  brandName: Yup.string()
    .max(35, "Brand name should be of 35 letters")
    .required("Brand name is required."),

  agencyID: Yup.number().nullable(),

  audienceLocation: Yup.array().when("agencyID", {
    is: (val) => !!val,
    then: () => Yup.array(),
    otherwise: () =>
      Yup.array()
        .min(1, "Atleast one audience location must be provided")
        .required("Audience location is required."),
  }),
  audienceLanguages: Yup.array().when("agencyID", {
    is: (val) => !!val,
    then: () => Yup.array(),
    otherwise: () =>
      Yup.array()
        .min(1, "Atleast one audience language must be provided")
        .required("Audience language is required."),
  }),

  siteCategory: Yup.array().when("agencyID", {
    is: (val) => !!val,
    then: () => Yup.array(),
    otherwise: () =>
      Yup.array()
        .min(1, "Atleast one category must be provided")
        .required("Category is required."),
  }),

  brandAvatar: Yup.array().when("agencyID", {
    is: (val) => !!val,
    then: () => Yup.mixed(),
    otherwise: () => Yup.mixed().required("Brand Logo is required."),
  }),

  about: Yup.string().required("About is required."),
  mau: Yup.string().matches(/^\d+$/, "Mau should be number"),
  onlineStore: Yup.string().matches(
    /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9:@%._?=/-]{2,}(\.[a-zA-Z0-9:@%._?=/-]{2,})(\.[a-zA-Z0-9:@%._?=/-]{2,})?/,
    "Enter correct url!"
  ),
  socialMedia: Yup.object().shape({
    facebook: Yup.string().matches(
      /^(https?:\/\/)?(www\.)?facebook\.com\/[a-zA-Z0-9(\.\?){3,50}?]/,
      "Enter correct url(facebook.com/username)!"
    ),
    instagram: Yup.string().matches(
      /^(https?:\/\/)?(www\.)?instagram\.com\/[a-zA-Z0-9(_\.\?){3,50}?]/,
      "Enter correct url(instagram.com/username)!"
    ),
    twitter: Yup.string().matches(
      /^(https?:\/\/)?(www\.)?twitter\.com\/[a-zA-Z0-9(_\.\?)?{3,50}]/,
      "Enter correct url(twitter.com/username)!"
    ),
    whatsapp: Yup.string().matches(
      /^\d{8,10}$/,
      "Whatsapp number should be of 10 digits"
    ),
  }),

  website: Yup.string().matches(
    /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9:@%._?=/-]{2,}(\.[a-zA-Z0-9:@%._?=/-]{2,})(\.[a-zA-Z0-9:@%._?=/-]{2,})?/,
    "Enter correct url!"
  ),
  others_category: Yup.string().when("siteCategory", {
    is: (val) => val?.includes("Others"),
    then: () => Yup.string().required("Others Category is required"),
    otherwise: () => Yup.string(),
  }),
});
